export const  preventBodyScroll = () => {
    document.body.classList.toggle('no-scroll');
}